import monkeyPatch from "./monkeyPatch.js";


monkeyPatch(Array.prototype,{
    /**
     * removes Elements from Array
     * @param callback (element,index)=>boolean
     * @returns Array of deleted Elements;
     */
    remove(callback){
        return this.reduceRight((deletedConfigs,element,index,orig)=>{
            if (callback(element,index)){
                deletedConfigs.push(orig.splice(index,1)[0]);
            }
            return deletedConfigs;
        },[]);
    }
});